import { useEffect } from "react";
import { isLocal, isDevelopment } from "@/config/prefs";

export function InjectGtag() {
  useEffect(() => {
    if (isLocal || isDevelopment) return;

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML = `
      (function() {
        var gtagScript = document.createElement('script');
        gtagScript.async = true;
        gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17823479577';
        var firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(gtagScript, firstScript);
      })();
      
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-17823479577");
    `;

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
}
